module.exports = __webpack_public_path__ + "static/media/mg_7972.51aee52c.jpg";